import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { articleSearchConditionItemNameConfig } from './ArticleSearchCondition.name';

/** 物件検索条件 */
enum ArticleSearchCondition {
  allArticles = '1',
  articleExpireCurrentMonthNoRegReLease = '2',
  articleExpirationNotificationTarget = '3',
}

const articleSearchConditionItemMap = new Map([
  ['1', articleSearchConditionItemNameConfig.allArticles],
  ['2', articleSearchConditionItemNameConfig.articleExpireCurrentMonthNoRegReLease],
  ['3', articleSearchConditionItemNameConfig.articleExpirationNotificationTarget],
]);

const rawValueToArticleSearchCondition = rawValueToEnumWithDefault(
  articleSearchConditionItemMap,
  ArticleSearchCondition.allArticles,
);

const articleSearchConditionToDisplay = enumToNameWithDefault(
  ArticleSearchCondition,
  articleSearchConditionItemNameConfig,
);

const articleSearchConditionToDisplayWithPrefix = enumToNameWithDefault(
  ArticleSearchCondition,
  articleSearchConditionItemNameConfig,
  true,
);

export {
  ArticleSearchCondition,
  articleSearchConditionToDisplay,
  articleSearchConditionToDisplayWithPrefix,
  rawValueToArticleSearchCondition,
};
